import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Bezier from './bezier';
import Point from './point';
import { createStyles, withStyles } from '@material-ui/core';
import cx from 'classnames';

var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return createStyles({
    focused: {},
    disabled: {
      pointerEvents: 'none'
    },
    //root styles if error occurs
    error: {
      '&:before': {
        borderBottomColor: 'danger'
      },
      '&:hover:not($disabled):before': {
        borderBottomColor: 'danger',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottomColor: 'danger'
        }
      }
    },
    standard: {},
    filled: {},
    root: {
      position: 'relative',
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },
    canvas: {
      cursor: 'pointer'
    },
    overlay: {
      left: 0,
      top: 0,
      bottom: 0,
      right: 0,
      backgroundColor: 'transparent',
      position: 'absolute',
      cursor: 'pointer'
    }
  });
};

var SignaturePad =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignaturePad, _React$Component);

  function SignaturePad(props) {
    var _this;

    _classCallCheck(this, SignaturePad);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignaturePad).call(this, props));
    _this.velocityFilterWeight = _this.props.velocityFilterWeight || 0.7;
    _this.minWidth = _this.props.minWidth || 0.5;
    _this.maxWidth = _this.props.maxWidth || 2.5;

    _this.dotSize = _this.props.dotSize || function () {
      return (this.minWidth + this.maxWidth) / 2;
    };

    _this.penColor = _this.props.penColor || 'black';
    _this.backgroundColor = _this.props.backgroundColor || 'rgba(0,0,0,0)';
    _this.onEnd = _this.props.onEnd;
    _this.onBegin = _this.props.onBegin;
    _this.canvasRef = React.createRef();
    _this.overlayRef = React.createRef();
    return _this;
  }

  _createClass(SignaturePad, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._ctx = this.canvasRef.current.getContext('2d');

      if (this.props.maxPadWidth && this.props.maxPadWidth < this.props.width) {
        this.canvasRef.current.width = this.props.maxPadWidth;
      }

      this.refresh();

      this._handleMouseEvents();

      this._handleTouchEvents(); //this._resizeCanvas();

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.defaultValue !== null && this.props.defaultValue === null) {
        this.writePlaceholder();
      } else if (prevProps.defaultValue != this.props.defaultValue || prevProps.maxPadWidth != this.props.maxPadWidth) {
        this.refresh();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.off();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.clear();
      if (this.props.defaultValue && this.props.defaultValue.length > 10) this.fromDataURL(this.props.defaultValue);else this.writePlaceholder();
    }
  }, {
    key: "writePlaceholder",
    value: function writePlaceholder() {
      this.clear();
      this._ctx = this.canvasRef.current.getContext('2d');
      this._ctx.font = 'italic 40px serif';
      this._ctx.fillStyle = 'grey';
      this._ctx.textAlign = 'center';

      this._ctx.fillText(this.props.placeholder, this.canvasRef.current.width / 2, this.props.height - 20);
    }
  }, {
    key: "clear",
    value: function clear(e) {
      e && e.preventDefault();
      var ctx = this._ctx;
      var canvas = this.canvasRef.current; // if max pad width is set, use it to limit the size of the canvas

      if (this.props.maxPadWidth && this.props.maxPadWidth < this.props.width) {
        canvas.width = this.props.maxPadWidth;
      }

      ctx.fillStyle = this.backgroundColor;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      this._reset();
    }
  }, {
    key: "toDataURL",
    value: function toDataURL(imageType, quality) {
      var canvas = this.canvasRef.current;
      return canvas.toDataURL.apply(canvas, arguments);
    }
  }, {
    key: "fromDataURL",
    value: function fromDataURL(dataUrl) {
      var self = this,
          image = new Image(),
          ratio = 1,
          // || window.devicePixelRatio
      width = this.canvasRef.current.width / ratio,
          height = this.canvasRef.current.height / ratio;

      this._reset();

      image.src = dataUrl;

      image.onload = function () {
        if (self.props.disabled) {
          self._ctx.fillStyle = 'grey';

          self._ctx.fillRect(0, 0, width, height);

          self._ctx.globalCompositeOperation = 'destination-in';
        } else {
          self._ctx.fillStyle = self.backgroundColor;

          self._ctx.clearRect(0, 0, width, height);

          self._ctx.fillRect(0, 0, width, height);
        }

        self._ctx.drawImage(image, 0, 0, width, height);
      };

      this._isEmpty = false;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._isEmpty;
    }
  }, {
    key: "_resizeCanvas",
    value: function _resizeCanvas() {
      var ctx = this._ctx,
          canvas = this.canvasRef.current; // When zoomed out to less than 100%, for some very strange reason,
      // some browsers report devicePixelRatio as less than 1
      // and only part of the canvas is cleared then.

      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      ctx.scale(ratio, ratio);
      this._isEmpty = true;
    }
  }, {
    key: "_reset",
    value: function _reset() {
      this.points = [];
      this._lastVelocity = 0;
      this._lastWidth = (this.minWidth + this.maxWidth) / 2;
      this._isEmpty = true;
      this._ctx.fillStyle = this.penColor;
    }
  }, {
    key: "_handleMouseEvents",
    value: function _handleMouseEvents() {
      this._mouseButtonDown = false;
      this.canvasRef.current.addEventListener('mousedown', this._handleMouseDown.bind(this));
      this.canvasRef.current.addEventListener('mousemove', this._handleMouseMove.bind(this));
      document.addEventListener('mouseup', this._handleMouseUp.bind(this)); // window.addEventListener('resize', this._resizeCanvas.bind(this));
    }
  }, {
    key: "_handleTouchEvents",
    value: function _handleTouchEvents() {
      // Pass touch events to canvas element on mobile IE.
      this.canvasRef.current.style.msTouchAction = 'none';
      this.canvasRef.current.addEventListener('touchstart', this._handleTouchStart.bind(this));
      this.canvasRef.current.addEventListener('touchmove', this._handleTouchMove.bind(this));
      document.addEventListener('touchend', this._handleTouchEnd.bind(this));
    }
  }, {
    key: "off",
    value: function off() {
      this.canvasRef.current.removeEventListener('mousedown', this._handleMouseDown);
      this.canvasRef.current.removeEventListener('mousemove', this._handleMouseMove);
      document.removeEventListener('mouseup', this._handleMouseUp);
      this.canvasRef.current.removeEventListener('touchstart', this._handleTouchStart);
      this.canvasRef.current.removeEventListener('touchmove', this._handleTouchMove);
      document.removeEventListener('touchend', this._handleTouchEnd);
      window.removeEventListener('resize', this._resizeCanvas);
    }
  }, {
    key: "_handleMouseDown",
    value: function _handleMouseDown(event) {
      if (event.which === 1) {
        this._mouseButtonDown = true;

        this._strokeBegin(event);
      }
    }
  }, {
    key: "_handleMouseMove",
    value: function _handleMouseMove(event) {
      if (this._mouseButtonDown) this._strokeUpdate(event);
    }
  }, {
    key: "_handleMouseUp",
    value: function _handleMouseUp(event) {
      if (event.which === 1 && this._mouseButtonDown) {
        this._mouseButtonDown = false;

        this._strokeEnd(event);
      }
    }
  }, {
    key: "_handleTouchStart",
    value: function _handleTouchStart(event) {
      var touch = event.changedTouches[0];

      this._strokeBegin(touch);
    }
  }, {
    key: "_handleTouchMove",
    value: function _handleTouchMove(event) {
      // Prevent scrolling.
      event.preventDefault();
      var touch = event.changedTouches[0];

      this._strokeUpdate(touch);
    }
  }, {
    key: "_handleTouchEnd",
    value: function _handleTouchEnd(event) {
      var wasCanvasTouched = event.target === this.canvasRef.current;
      if (wasCanvasTouched) this._strokeEnd(event);
    }
  }, {
    key: "_strokeUpdate",
    value: function _strokeUpdate(event) {
      var point = this._createPoint(event);

      this._addPoint(point);
    }
  }, {
    key: "_strokeBegin",
    value: function _strokeBegin(event) {
      if (this.isEmpty() === true) this.clear();

      this._reset();

      this._strokeUpdate(event);

      if (typeof this.onBegin === 'function') this.onBegin(event);
    }
  }, {
    key: "_strokeDraw",
    value: function _strokeDraw(point) {
      var ctx = this._ctx,
          dotSize = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
      ctx.beginPath();

      this._drawPoint(point.x, point.y, dotSize);

      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "_strokeEnd",
    value: function _strokeEnd(event) {
      var canDrawCurve = this.points.length > 2,
          point = this.points[0];
      if (!canDrawCurve && point) this._strokeDraw(point);
      if (typeof this.onEnd === 'function') this.onEnd(event);
      this.props.onChange(this.toDataURL());
    }
  }, {
    key: "_createPoint",
    value: function _createPoint(event) {
      var rect = this.canvasRef.current.getBoundingClientRect();
      return new Point(event.clientX - rect.left, event.clientY - rect.top);
    }
  }, {
    key: "_addPoint",
    value: function _addPoint(point) {
      var points = this.points,
          c2,
          c3,
          curve,
          tmp;
      points.push(point);

      if (points.length > 2) {
        // To reduce the initial lag make it work with 3 points
        // by copying the first point to the beginning.
        if (points.length === 3) points.unshift(points[0]);
        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
        c2 = tmp.c2;
        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
        c3 = tmp.c1;
        curve = new Bezier(points[1], c2, c3, points[2]);

        this._addCurve(curve); // Remove the first element from the list,
        // so that we always have no more than 4 points in points array.


        points.shift();
      }
    }
  }, {
    key: "_calculateCurveControlPoints",
    value: function _calculateCurveControlPoints(s1, s2, s3) {
      var dx1 = s1.x - s2.x,
          dy1 = s1.y - s2.y,
          dx2 = s2.x - s3.x,
          dy2 = s2.y - s3.y,
          m1 = {
        x: (s1.x + s2.x) / 2.0,
        y: (s1.y + s2.y) / 2.0
      },
          m2 = {
        x: (s2.x + s3.x) / 2.0,
        y: (s2.y + s3.y) / 2.0
      },
          l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1),
          l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2),
          dxm = m1.x - m2.x,
          dym = m1.y - m2.y,
          k = l2 / (l1 + l2),
          cm = {
        x: m2.x + dxm * k,
        y: m2.y + dym * k
      },
          tx = s2.x - cm.x,
          ty = s2.y - cm.y;
      return {
        c1: new Point(m1.x + tx, m1.y + ty),
        c2: new Point(m2.x + tx, m2.y + ty)
      };
    }
  }, {
    key: "_addCurve",
    value: function _addCurve(curve) {
      var startPoint = curve.startPoint,
          endPoint = curve.endPoint,
          velocity,
          newWidth;
      velocity = endPoint.velocityFrom(startPoint);
      velocity = this.velocityFilterWeight * velocity + (1 - this.velocityFilterWeight) * this._lastVelocity;
      newWidth = this._strokeWidth(velocity);

      this._drawCurve(curve, this._lastWidth, newWidth);

      this._lastVelocity = velocity;
      this._lastWidth = newWidth;
    }
  }, {
    key: "_drawPoint",
    value: function _drawPoint(x, y, size) {
      var ctx = this._ctx;
      ctx.moveTo(x, y);
      ctx.arc(x, y, size, 0, 2 * Math.PI, false);
      this._isEmpty = false;
    }
  }, {
    key: "_drawCurve",
    value: function _drawCurve(curve, startWidth, endWidth) {
      var ctx = this._ctx,
          widthDelta = endWidth - startWidth,
          drawSteps,
          width,
          i,
          t,
          tt,
          ttt,
          u,
          uu,
          uuu,
          x,
          y;
      drawSteps = Math.floor(curve.length());
      ctx.beginPath();

      for (i = 0; i < drawSteps; i++) {
        // Calculate the Bezier (x, y) coordinate for this step.
        t = i / drawSteps;
        tt = t * t;
        ttt = tt * t;
        u = 1 - t;
        uu = u * u;
        uuu = uu * u;
        x = uuu * curve.startPoint.x;
        x += 3 * uu * t * curve.control1.x;
        x += 3 * u * tt * curve.control2.x;
        x += ttt * curve.endPoint.x;
        y = uuu * curve.startPoint.y;
        y += 3 * uu * t * curve.control1.y;
        y += 3 * u * tt * curve.control2.y;
        y += ttt * curve.endPoint.y;
        width = startWidth + ttt * widthDelta;

        this._drawPoint(x, y, width);
      }

      ctx.closePath();
      ctx.fill();
    }
  }, {
    key: "_strokeWidth",
    value: function _strokeWidth(velocity) {
      return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
    }
  }, {
    key: "onFocusCanvas",
    value: function onFocusCanvas() {
      this.props.onFocus && this.props.onFocus();
      if (this.overlayRef.current) this.overlayRef.current.style.visibility = 'hidden';
    }
  }, {
    key: "onBlurCanvas",
    value: function onBlurCanvas() {
      this.props.onBlur && this.props.onBlur();
      if (this.overlayRef.current) this.overlayRef.current.style.visibility = 'visible';
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _cx2,
          _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          variant = _this$props.variant,
          disabled = _this$props.disabled,
          width = _this$props.width,
          height = _this$props.height,
          error = _this$props.error,
          enableOnFocus = _this$props.enableOnFocus;
      var signatureStyles = cx((_cx = {}, _defineProperty(_cx, classes.root, true), _defineProperty(_cx, classes[variant], true), _defineProperty(_cx, classes.error, error), _cx));
      return React.createElement("div", {
        className: disabled ? cx((_cx2 = {}, _defineProperty(_cx2, classes.disabled, true), _defineProperty(_cx2, signatureStyles, true), _cx2)) : signatureStyles
      }, React.createElement("canvas", {
        ref: this.canvasRef,
        width: width,
        height: height,
        className: classes.canvas,
        tabIndex: disabled ? -1 : 0,
        style: {
          outline: 0
        },
        onBlur: this.onBlurCanvas.bind(this),
        onFocus: this.onFocusCanvas.bind(this)
      }), enableOnFocus && React.createElement("div", {
        className: classes.overlay,
        ref: this.overlayRef,
        onClick: function onClick() {
          return _this2.canvasRef.current.focus();
        }
      }));
    }
  }]);

  return SignaturePad;
}(React.Component);

SignaturePad.defaultProps = {
  variant: 'standard',
  disabled: false,
  maxPadWidth: 0
};
export default withStyles(styles, {
  name: 'ECSignaturePad'
})(SignaturePad);